import { React, useState, useEffect } from 'react';
import { apiCall } from '../apiclient';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SongListCriteriaList from './SongListCriteriaList';

export default function SongListTagCriteria(props) {
    const [availableItems, setAvailableItems ] = 
        useState({});
    const [includeItems, setIncludeItems ] = 
        useState({});
    const [excludeItems, setExcludeItems ] =
        useState({});
    const [itemCount, setItemCount] =
        useState(null);
    /* const [currentCriteria, setCurrentCriteria] =
        useState(null); */

    useEffect(() => {
        // console.log(`SongListTagCriteria.useEffect ${props.currentCriteria}`);
        if (itemCount === null) {
            let itmCount = {};
            itmCount['available'] = 0;
            itmCount['include'] = 0;
            itmCount['exclude'] = 0;
            let availItems = {};
            let inclItems = {};
            let exclItems = {};
            let props_currentCriteria = JSON.parse(props.currentCriteria);
            props_currentCriteria['criteria'].forEach((criteria) => {
                if (criteria['include_tags'] !== undefined) {
                    criteria['include_tags'].forEach((t) => {
                        itmCount['include']++;
                        inclItems[t] = {'itemId':t, 'itemDescription': t, 'itemGroup': 'include'};
                    })
                }
                if (criteria['exclude_tags'] !== undefined) {
                    criteria['exclude_tags'].forEach((t) => {
                        itmCount['exclude']++;
                        exclItems[t] = {'itemId':t, 'itemDescription':t, 'itemGroup':'exclude'};
                    })
                }
            })
            apiCall('get', `/users/${props.user.uuid}/tags?status=PRIVATE&status=PUBLIC`).then((allTags) => {
                // console.log(JSON.stringify({'allTags': allTags}));
                for (let tag in allTags.tags) {
                    if (inclItems[tag] === undefined && exclItems[tag] === undefined) {
                    itmCount['available']++;
                    availItems[tag] = {'itemId': tag, 'itemDescription': tag, 'itemGroup':'available'}
                    }
                }
                // console.log(JSON.stringify(availItems));
                setItemCount(JSON.stringify(itmCount));
                setAvailableItems(availItems);
                setIncludeItems(inclItems);
                setExcludeItems(exclItems);
            }).catch((ex) => {
                console.error("Error getting active user tags: " + ex);
                setItemCount(JSON.stringify({}));
            })
        }
    }, [itemCount])

    function deleteFromArray(stringArray, value) {
        let newArray = [];
        for (let index in stringArray) {
            if (stringArray[index] !== value) {
                newArray.push(stringArray[index]);
            }
        }
        return newArray;
    }

    function updateCurrentCriteria(criteria, op, criteriaKey, tagValue) {
        // console.log(`SongListTagCriteria.updateCurrentCriteria currentCriteria: ${criteria}`);
        let curCriteria = JSON.parse(criteria);
        let found = false;
        let newCriteria = [];
        // console.log(`SongListTagCriteria.updateCurrentCriteria curCriteria.criteria: ${JSON.stringify(curCriteria.criteria)}`);
        for (let idx in curCriteria.criteria) {
            // console.log(`for ${idx} ${JSON.stringify(curCriteria.criteria)}`);
            if (curCriteria.criteria[idx][criteriaKey] !== undefined) {
                found = true;
                if (op === 'add') {
                    // console.log(`add ${JSON.stringify(curCriteria.criteria[idx][criteriaKey])}`);
                    curCriteria.criteria[idx][criteriaKey].push(tagValue);
                }
                if (op === 'delete') {
                    curCriteria.criteria[idx][criteriaKey] = 
                        deleteFromArray(curCriteria.criteria[idx][criteriaKey], tagValue);
                }
                if (curCriteria.criteria[idx][criteriaKey].length !== 0) {
                    newCriteria.push(curCriteria.criteria[idx]);
                }
            } else {
                newCriteria.push(curCriteria.criteria[idx]);
            }
        }
        if (found === false) {
            let curCriteriaItem = {};
            curCriteriaItem[criteriaKey] = [tagValue];
            newCriteria.push(curCriteriaItem);
        }
        curCriteria.criteria = newCriteria;
        // console.log(`SongListTagCriteria.updateCurrentCriteria: ${JSON.stringify(curCriteria)}`);
        return JSON.stringify(curCriteria);
    }

    function updateTagCriteria(tagItem, from, to) {
        // console.log(`SongListTagCriteria.updateTagCriteria moving ${tagItem.itemId} from ${from} to ${to}`);
        let itmCount = JSON.parse(itemCount);
        let newCriteria = props.currentCriteria;
        switch(from) {
            case 'available':
                let availItems = JSON.parse(JSON.stringify(availableItems));
                if (to == 'include') {
                    let inclItems = JSON.parse(JSON.stringify(includeItems));
                    inclItems[tagItem.itemId] = availItems[tagItem.itemId];
                    inclItems[tagItem.itemId].itemGroup = to;
                    delete availItems[tagItem.itemId];
                    itmCount[from]--;
                    itmCount[to]++;
                    setIncludeItems(inclItems);
                    setAvailableItems(availItems);
                    newCriteria = updateCurrentCriteria(newCriteria, 'add', 'include_tags', tagItem.itemId);
                }
                if (to == 'exclude') {
                    let exclItems = JSON.parse(JSON.stringify(excludeItems));
                    exclItems[tagItem.itemId] = availItems[tagItem.itemId];
                    exclItems[tagItem.itemId].itemGroup = to;
                    delete availItems[tagItem.itemId];
                    itmCount[from]--;
                    itmCount[to]++;
                    setExcludeItems(exclItems);
                    setAvailableItems(availItems);
                    newCriteria = updateCurrentCriteria(newCriteria, 'add', 'exclude_tags', tagItem.itemId);
                }
                break;
            case 'include':
                let inclItems = JSON.parse(JSON.stringify(includeItems));
                if (to == 'available') {
                    let availItems = JSON.parse(JSON.stringify(availableItems));
                    availItems[tagItem.itemId] = inclItems[tagItem.itemId];
                    availItems[tagItem.itemId].itemGroup = to;
                    delete inclItems[tagItem.itemId];
                    itmCount[from]--;
                    itmCount[to]++;
                    setAvailableItems(availItems);
                    setIncludeItems(inclItems);
                    newCriteria = updateCurrentCriteria(newCriteria, 'delete', 'include_tags', tagItem.itemId);
                }
                if (to == 'exclude') {
                    let exclItems = JSON.parse(JSON.stringify(excludeItems));
                    exclItems[tagItem.itemId] = inclItems[tagItem.itemId];
                    exclItems[tagItem.itemId].itemGroup = to;
                    delete inclItems[tagItem.itemId];
                    itmCount[from]--;
                    itmCount[to]++;
                    setExcludeItems(exclItems);
                    setIncludeItems(inclItems);
                    newCriteria = updateCurrentCriteria(newCriteria, 'delete', 'include_tags', tagItem.itemId);
                    newCriteria = updateCurrentCriteria(newCriteria, 'add', 'exclude_tags', tagItem.itemId);
                }
                break;
            case 'exclude':
                let exclItems = JSON.parse(JSON.stringify(excludeItems));
                if (to == 'available') {
                    let availItems = JSON.parse(JSON.stringify(availableItems));
                    availItems[tagItem.itemId] = exclItems[tagItem.itemId];
                    availItems[tagItem.itemId].itemGroup = to;
                    delete exclItems[tagItem.itemId];
                    itmCount[from]--;
                    itmCount[to]++;
                    setAvailableItems(availItems);
                    setExcludeItems(exclItems);
                    newCriteria = updateCurrentCriteria(newCriteria, 'delete', 'exclude_tags', tagItem.itemId);
                }
                if (to == 'include') {
                    let inclItems = JSON.parse(JSON.stringify(includeItems));
                    inclItems[tagItem.itemId] = exclItems[tagItem.itemId];
                    inclItems[tagItem.itemId].itemGroup = to;
                    delete exclItems[tagItem.itemId];
                    itmCount[from]--;
                    itmCount[to]++;
                    setIncludeItems(inclItems);
                    setExcludeItems(exclItems);
                    newCriteria = updateCurrentCriteria(newCriteria, 'delete', 'exclude_tags', tagItem.itemId);
                    newCriteria = updateCurrentCriteria(newCriteria, 'add', 'include_tags', tagItem.itemId);
                }
                break;
        }
        // console.log(`SongListTagCriteria.updateTagCriteria ${JSON.stringify(itmCount)}`);
        // console.log(`SongListTagCriteria.updateTagCriteria ${newCriteria}`);
        props.currentCriteriaUpdate(newCriteria);
        setItemCount(JSON.stringify(itmCount));
    }

    return(
        <Row style={{ 'height': '44vh', 'max-height':'44vh'}}>
            <Col style={{ 'height': '100%', 'max-height':'100%'}}>
                <Card style={{ 'height': '100%', 'max-height':'100%'}}>
                    <Card.Title className='mx-auto'>Available Tags</Card.Title>
                    <SongListCriteriaList items={availableItems}
                                        itemCount={itemCount}
                                        itemMover={updateTagCriteria}
                                        criteriaType='tag'
                                        itemGroup='available' />
                    <Card.Footer className='text-muted'>Drag and drop tags to use as selection criteria</Card.Footer>
                </Card>
            </Col>
            <Col style={{ 'height': '100%', 'max-height':'100%'}}>
                <Card style={{ 'height': '100%', 'max-height':'100%'}}>
                    <Card.Title className='mx-auto'>Included Tags</Card.Title>
                    <SongListCriteriaList items={includeItems}
                                        itemCount={itemCount}
                                        itemMover={updateTagCriteria}
                                        criteriaType='tag'
                                        itemGroup='include' />
                    <Card.Footer className='text-muted'>Songs with these tags will be selected for the list</Card.Footer>
                </Card>
            </Col>
            <Col style={{ 'height': '100%', 'max-height':'100%'}}>
                <Card style={{ 'height': '100%', 'max-height':'100%'}}>
                    <Card.Title className='mx-auto'>Excluded Tags</Card.Title>
                    <SongListCriteriaList items={excludeItems}
                                        itemCount={itemCount}
                                        itemMover={updateTagCriteria}
                                        criteriaType='tag'
                                        itemGroup='exclude' />
                    <Card.Footer className='text-muted'>Songs with these tags will be excluded from the list</Card.Footer>
                </Card>
            </Col>
        </Row>
    )
}